import { POST, PATCH, GET, POSTU } from './Httpr.js';


export function jwtValidate(jwt){

    return true;
}

export async function logIn(dni, password){
    let url = 'auth/login';
    let requestData = {
        dni,
        password
    }

    const timeout = 3000;

    let rsp = await POST(url, requestData, timeout);

    return rsp;
}

export async function updateUserData(request){
    let url = 'users/update';
    
    let rsp = await PATCH(url, request);

    return rsp;
}

export async function updateUserPassword(request){
    let url = 'users/changePassword';
    let requestData = {
        password: request.password,
        newPassword: request.newPassword
    }

    let rsp = await PATCH(url, requestData);

    return rsp;
}

export async function refreshToken(){
    let url = 'auth/refresh';

    let rsp = await POST(url, {});

    return rsp;
}

export async function serachByName(request){
    let url = 'users/search';
    let requestData = {
        page: request.page || 1,
        name: request.name
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getInfoByUsrId(request){
    let url = 'users/info';
    let requestData = {
        id: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export function logOut(){
    localStorage.clear();
    window.location.replace('?');
}


export async function uploadProfilePicture(request){
    let url = "users/setProfilePic";
    
    let rsp = await POSTU(url, request);

    return rsp;
}